// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WeZK","select":"styles_select__2Syw7"};